import { Link } from "@inertiajs/react"
import { Component, type ErrorInfo, type ReactNode } from "react"

import { AppLogoIcon } from "@/components/app-logo-icon"

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Uncaught error:", error, info)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-[#0a0a0a] p-8 text-center">
          <AppLogoIcon className="mb-8 h-8 w-auto text-[#e0e0e0]" />
          <h1 className="mb-3 text-2xl font-bold text-[#e0e0e0]">
            Something broke
          </h1>
          <p className="max-w-md text-[#a0a0a0]">
            Whoops — Truman probably got an alert about this, but you could text
            him to make sure.
          </p>
          <Link
            href="/"
            className="mt-6 text-sm font-medium text-[#39FF14] underline underline-offset-2 hover:text-[#32e012]"
          >
            Back to safety
          </Link>
        </div>
      )
    }

    return this.props.children
  }
}
